<template>
  <button @click="exportTransaction" class="btn btn-info is-border-1 mr-1 mb-2">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/client-point-transaction', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          const formatPoint = (item) => {
            const point = Math.abs(item.point);
            return item.action === 'plus' ? point : -point;
          };
          const getTotalPoint = (item) => {
            const point = Math.abs(item.point);
            return item.action === 'plus'
                ? item.beforePoint + point
                : item.beforePoint - point;
          };
          let row = {
            domain: item.client && item.client.domain ? item.client.domain : '',
            customer: item.customer && item.customer.name ? item.customer.name : '',
            order: item.order && item.order.code ? item.order.code : '',
            type: this.$t(item.type) || '',
            point: formatPoint(item),
            afterPoint: getTotalPoint(item),
            content: item.content || '',
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss')
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'point-transaction-history.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: 'Domain', key: 'domain', width: 20},
        {header: this.$t('customer'), key: 'customer', width: 20},
        {header: this.$t('order'), key: 'order', width: 20},
        {header: this.$t('type'), key: 'type', width: 20},
        {header: this.$t('point'), key: 'point', width: 20},
        {header: this.$t('afterPoint'), key: 'afterPoint', width: 20},
        {header: this.$t('content'), key: 'content', width: 60},
        {header: this.$t('createTime'), key: 'createTime', width: 20},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        createTime: "Create time",
        info: "Info",
        point: "Point",
        afterPoint: "After point",
        rank: "Rank",
        content: "Content",
        order: "Order",
        customer: "Customer",
        plus: "Plus",
        minus: "Minus",
        enterKeyword: "Enter keyword",
        selectType: "Select type",
        manual: "Manual",
        selectAction: "Select action",
        payment: "Payment",
      },
      vi: {
        createTime: "Tạo lúc",
        info: "Thông tin",
        point: "Điểm",
        afterPoint: "Sau khi",
        rank: "Rank",
        content: "Nội dung",
        order: "Đơn hàng",
        customer: "Khách hàng",
        plus: "Tăng",
        minus: "Giảm",
        enterKeyword: "Nhập từ khóa",
        selectType: "Chọn loại",
        manual: "Thủ công",
        selectAction: "Chọn hành động",
        payment: "Thanh toán",
      }
    }
  }
}
</script>